module.exports = __webpack_public_path__ + "img/speedometer_icon_177249.8a1ee435.svg";